import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Desplegable from "../../desplegable";

export default class VistaDatosCiviles extends Component {
  render() {
    let vistaDatosCiviles =
      this.props.DatosProvincia.web || this.props.DatosProvincia.addressHq ? (
        <React.Fragment>
         
          <Desplegable
            Toogle={"Lugar de la Sede"}
            Text={
              <Col>
                <Row>
                  <Col lg="6" className="border">
                    <h6>Dirección Postal</h6>
                    <p>{this.props.DatosProvincia.addressHq}</p>
                  </Col>
                  <Col lg="6" className="border">
                    <h6>Teléfono</h6>
                    <p>{this.props.DatosProvincia.telephoneHq}</p>
                  </Col>
                </Row>
                <Row>
                  <Col lg="6" className="border">
                    <h6>Código Postal</h6>
                    <p>{this.props.DatosProvincia.postcodeHq}</p>
                  </Col>
                  <Col lg="6" className="border">
                    <h6>País</h6>
                    <p>{this.props.DatosProvincia.countryHq}</p>
                  </Col>
                </Row>
                <Row>
                  <Col lg="6" className="border">
                    <h6>Ciudad</h6>
                    <p>{this.props.DatosProvincia.cityHq}</p>
                  </Col>
                </Row>
              </Col>
            }
          />
           <Container className="mt-3">
            <Row>
              <Col lg="6" className="border">
                <h6>Web Provincia</h6>
                <p>{this.props.DatosProvincia.web}</p>
              </Col>
              <Col lg="6" className="border">
                <h6>RRSS Provincia</h6>
                {this.props.DatosProvincia.rrsses.length !== 0 && this.props.DatosProvincia.rrsses.filter(s => s.url !== '').map(s => <p>{s.name}: {s.url}</p>)}
              </Col>
            </Row>
          </Container>
        </React.Fragment>
      ) : (
        <p className="ml-3">No hay datos actualmente</p>
      );
    return <React.Fragment>{vistaDatosCiviles}</React.Fragment>;
  }
}
